// import React, { useState, useEffect } from "react";
// import {
//   Container,
//   Row,
//   Col,
//   Form,
//   Button,
//   Card,
//   Badge,
//   Alert,
//   InputGroup,
//   Modal,
//   Spinner,
// } from "react-bootstrap";
// import "bootstrap/dist/css/bootstrap.min.css";
// import Swal from "sweetalert2";
// import { sendcode, getByEventId, getpackagebyevent, saveeventregistration, editregistration } from "../store/slices/userSlice";
// import { useSearchParams } from "react-router-dom";
// import axios from "axios";

// export default function EventRegistrationPage() {
//   const [searchParams] = useSearchParams();
//   const eventId = searchParams.get("id") || "";
//   const [packages, setPackages] = useState([]);
//   const [loading, setLoading] = useState(false);

//   // registrationformData now derives adults/kids from selectedPasses
//   const [registrationformData, setRegistrationformData] = useState({
//     id: 0,
//     event: "",
//     phonenumber: "",
//     email: "",
//     amount: 0,
//     packages: [],
//     members: [],
//     status: "1",
//     name: "",
//     adults: 0, // This will be a derived sum
//     kids: 0,   // This will be a derived sum
//   });

//   const [formData, setFormData] = useState({
//     id: 0,
//     name: "",
//     startdate: "",
//     enddate: "",
//     starttime: "",
//     endtime: "",
//     description: "",
//     registrationallowed: "",
//     status: "",
//   });

//   // selectedPasses now includes adultsRegistered and kidsRegistered for each item
//   const [selectedPasses, setSelectedPasses] = useState([]);
//   const [guests, setGuests] = useState([]);
//   const [formErrors, setFormErrors] = useState({});
//   const [showAlert, setShowAlert] = useState(false);
//   const [alertMessage, setAlertMessage] = useState("");
//   const [alertVariant, setAlertVariant] = useState("danger");

//   // Authentication State
//   const [showAuthModal, setShowAuthModal] = useState(true);
//   const [authEmail, setAuthEmail] = useState("");
//   const [authCode, setAuthCode] = useState("");
//   const [generatedCode, setGeneratedCode] = useState("");
//   const [isCodeSent, setIsCodeSent] = useState(false);
//   const [authError, setAuthError] = useState("");
//   const [isAuthenticated, setIsAuthenticated] = useState(false);
//   const [isMember, setIsMember] = useState(false);
//   const [isLoadingAuth, setIsLoadingAuth] = useState(false);
//   const [name, setName] = useState(""); // Registrant's name from authentication/profile

//   // State for summary modal
//   const [showSummaryModal, setShowSummaryModal] = useState(false);

//   // Derive total adults and kids from selectedPasses
//   useEffect(() => {
//     const totalAdultsRegistered = selectedPasses.reduce(
//       (sum, item) => sum + item.adultsRegistered, 0
//     );
//     const totalKidsRegistered = selectedPasses.reduce(
//       (sum, item) => sum + item.kidsRegistered, 0
//     );

//     setRegistrationformData(prev => ({
//       ...prev,
//       adults: totalAdultsRegistered,
//       kids: totalKidsRegistered
//     }));
//   }, [selectedPasses]);

//   useEffect(() => {
//     if (eventId) {
//       fetchEventDetails(eventId);
//     }
//   }, [eventId]);

//   const fetchEventDetails = async (id) => {
//     setLoading(true);
//     try {
//       const eventResponse = await getByEventId(id);
//       if (eventResponse?.status === 200 && eventResponse.data) {
//         setFormData((prev) => ({
//           ...prev,
//           ...eventResponse.data,
//         }));
//       } else {
//         Swal.fire("Error", "Error fetching event details!", "error");
//       }

//       const packagesResponse = await getpackagebyevent(id);
//       if (packagesResponse?.status === 200 && Array.isArray(packagesResponse.data)) {
//         const mappedPackages = packagesResponse.data.map(pkg => ({
//           id: pkg.id,
//           name: pkg.name,
//           rate: pkg.rate,
//           member: pkg.member,
//           status: pkg.status,
//           adults: pkg.adults || 0,
//           kids: pkg.kids || 0,
//           startdate: pkg.formattedstartdate,
//           enddate: pkg.formattedenddate,
//           type: pkg.type,
//         }));

//         setPackages(mappedPackages);
//       } else {
//         Swal.fire("Error", "Error fetching package details!", "error");
//         setPackages([]);
//       }
//     } catch (error) {
//       console.error("Error fetching event or package data:", error);
//       Swal.fire("Error", "Error fetching event or package data!", "error");
//     } finally {
//       setLoading(false);
//     }
//   };

//   // useEffect to manage guest list based on total adults/kids from selectedPasses
//   // This useEffect will be removed or simplified as guest details section is removed
//   useEffect(() => {
//     // Since guest information section is removed, we don't need to generate guest objects here.
//     // The 'members' payload in registration will now just use the main registrant's info,
//     // or if other 'members' are implicitly needed, they would be derived differently.
//     // For now, setting guests to an empty array.
//     setGuests([]);
//   }, [selectedPasses]); // Still depends on selectedPasses to trigger potential changes in guest logic if it were present.

//   const handleSendCode = async () => {
//     setAuthError("");
//     setIsLoadingAuth(true);

//     if (!authEmail || !/\S+@\S+\.\S/.test(authEmail)) {
//       setAuthError("Please enter a valid email address.");
//       setIsLoadingAuth(false);
//       return;
//     }

//     const randomCode = Math.floor(100000 + Math.random() * 900000).toString();
//     setGeneratedCode(randomCode);

//     try {
//       const response = await sendcode(authEmail.toLowerCase(), randomCode);

//       if (response?.status === 200 && response.data) {
//         Swal.fire("Success", "Verification code sent to your email!", "success");
//         setName(response.data[0]?.name || "");
//         setIsCodeSent(true);
//       } else if (response?.data?.error === "Mail Not Registered") {
//         Swal.fire("Info", "Email not registered. Proceeding as a guest.", "info");
//         setIsAuthenticated(true);
//         setIsMember(false);
//         setShowAuthModal(false);
//         setAlertMessage("Welcome Guest! You have access to general passes.");
//         setAlertVariant("info");
//         setShowAlert(true);
//         setRegistrationformData(prev => ({
//           ...prev,
//           email: authEmail
//         }));
//       } else {
//         const errorMessage = response?.data?.error || "Failed to send code. Please try again.";
//         Swal.fire("Error", errorMessage, "error");
//         setAuthError(errorMessage);
//         setIsCodeSent(false);
//       }
//     } catch (error) {
//       console.error("Error sending code:", error);
//       setAuthError("Network error. Please try again later.");
//       Swal.fire("Error", "Network error. Please try again later.", "error");
//       setIsCodeSent(false);
//     }
//     finally {
//       setIsLoadingAuth(false);
//     }
//   };

//   const handleVerifyCode = async () => {
//     setAuthError("");
//     setIsLoadingAuth(true);

//     if (!authCode || authCode.length !== 6) {
//       setAuthError("Please enter the 6-digit code.");
//       setIsLoadingAuth(false);
//       return;
//     }

//     try {
//       await new Promise(resolve => setTimeout(resolve, 1500));

//       if (authCode === generatedCode) {
//         setIsAuthenticated(true);
//         setIsMember(true);
//         setShowAuthModal(false);
//         setAlertMessage(`Welcome ${name || 'Member'}!`);
//         setAlertVariant("success");
//         setShowAlert(true);
//         setRegistrationformData(prev => ({
//           ...prev,
//           email: authEmail
//         }));
//       } else {
//         setAuthError("Invalid code. Please try again.");
//       }
//     } catch (error) {
//       setAuthError("Network error during verification. Please try again.");
//     } finally {
//       setIsLoadingAuth(false);
//     }
//   };

//   const handleRegistrantInfoChange = (e) => {
//     const { name, value } = e.target;
//     setRegistrationformData(prev => ({
//       ...prev,
//       [name]: value
//     }));
//     if (formErrors[name] && value.trim()) {
//       const newErrors = { ...formErrors };
//       delete newErrors[name];
//       setFormErrors(newErrors);
//     }
//   };

//   const handlePassQuantityChange = (pkgId, change) => {
//     setSelectedPasses(prevSelected => {
//       const existingPassIndex = prevSelected.findIndex(item => item.package.id === pkgId);
//       const pkgToModify = packages.find(pkg => pkg.id === pkgId);

//       if (!pkgToModify || pkgToModify.status !== "1") {
//         setAlertMessage(`The "${pkgToModify?.name || 'selected package'}" is currently unavailable.`);
//         setAlertVariant("warning");
//         setShowAlert(true);
//         return prevSelected;
//       }

//       if (pkgToModify.member === "yes" && !isMember) {
//         setAlertMessage(`The "${pkgToModify.name}" is for members only. Please register or verify as a member.`);
//         setAlertVariant("warning");
//         setShowAlert(true);
//         return prevSelected;
//       }

//       if (existingPassIndex !== -1) {
//         const newSelected = [...prevSelected];
//         const currentItem = newSelected[existingPassIndex];
//         const newQuantity = currentItem.quantity + change;

//         if (newQuantity <= 0) {
//           return newSelected.filter(item => item.package.id !== pkgId);
//         } else {
//           const maxAdultsForNewQty = newQuantity * pkgToModify.adults;
//           const maxKidsForNewQty = newQuantity * pkgToModify.kids;

//           newSelected[existingPassIndex] = {
//             ...currentItem,
//             quantity: newQuantity,
//             // CORRECTED: Auto-increase adultsRegistered/kidsRegistered when quantity increases
//             adultsRegistered: change > 0 ? maxAdultsForNewQty : Math.min(currentItem.adultsRegistered, maxAdultsForNewQty),
//             kidsRegistered: change > 0 ? maxKidsForNewQty : Math.min(currentItem.kidsRegistered, maxKidsForNewQty)
//           };
//           return newSelected;
//         }
//       } else if (change > 0) {
//         // Initial selection: set registered adults/kids to max allowed by 1 quantity
//         return [...prevSelected, {
//           package: pkgToModify,
//           quantity: 1,
//           adultsRegistered: pkgToModify.adults, // Default to max allowed by 1 pass
//           kidsRegistered: pkgToModify.kids
//         }];
//       }
//       return prevSelected;
//     });
//     setFormErrors((prevErrors) => {
//       const newErrors = { ...prevErrors };
//       delete newErrors.selectedPasses;
//       return newErrors;
//     });
//   };

//   // New handler for per-package adult/kid count changes
//   const handleRegisteredGuestCountChange = (pkgId, type, value) => {
//     setSelectedPasses(prevSelected => {
//       return prevSelected.map(item => {
//         if (item.package.id === pkgId) {
//           const maxAllowed = item.quantity * (type === 'adults' ? item.package.adults : item.package.kids);
//           const newValue = Math.max(0, Math.min(parseInt(value) || 0, maxAllowed));
//           return {
//             ...item,
//             [type === 'adults' ? 'adultsRegistered' : 'kidsRegistered']: newValue
//           };
//         }
//         return item;
//       });
//     });
//   };

//   // These functions are no longer directly used as guest section is removed
//   // const handleGuestChange = (id, field, value) => {
//   //   const newGuests = guests.map((guest) =>
//   //     guest.id === id ? { ...guest, [field]: value } : guest
//   //   );
//   //   setGuests(newGuests);
//   //   if (formErrors[`guest-${id}-${field}`] && value.trim()) {
//   //     const newErrors = { ...formErrors };
//   //     delete newErrors[`guest-${id}-${field}`];
//   //     setFormErrors(newErrors);
//   //   }
//   // };

//   // const handleCopyGuestDetails = (targetGuestId, sourceGuestId) => {
//   //   const sourceGuest = guests.find(g => g.id === sourceGuestId);
//   //   if (!sourceGuest) return;

//   //   setGuests(prevGuests => {
//   //     return prevGuests.map(guest => {
//   //       if (guest.id === targetGuestId) {
//   //         return {
//   //           ...guest,
//   //           name: sourceGuest.name,
//   //           email: sourceGuest.email,
//   //           phone: sourceGuest.phone
//   //         };
//   //       }
//   //       return guest;
//   //     });
//   //   });

//   //   setFormErrors(prevErrors => {
//   //     const newErrors = { ...prevErrors };
//   //     delete newErrors[`guest-${targetGuestId}-name`];
//   //     delete newErrors[`guest-${targetGuestId}-email`];
//   //     delete newErrors[`guest-${targetGuestId}-phone`];
//   //     return newErrors;
//   //   });
//   // };

//   // const handleCopyRegistrantToGuest = (targetGuestId) => {
//   //   setGuests(prevGuests => {
//   //     return prevGuests.map(guest => {
//   //       if (guest.id === targetGuestId) {
//   //         return {
//   //           ...guest,
//   //           name: name, // From auth state
//   //           email: authEmail, // From auth state
//   //           phone: registrationformData.phonenumber
//   //         };
//   //       }
//   //       return guest;
//   //     });
//   //   });

//   //   setFormErrors(prevErrors => {
//   //     const newErrors = { ...prevErrors };
//   //     delete newErrors[`guest-${targetGuestId}-name`];
//   //     delete newErrors[`guest-${targetGuestId}-email`];
//   //     delete newErrors[`guest-${targetGuestId}-phone`];
//   //     return newErrors;
//   //   });
//   // };

//   const validateForm = () => {
//     const errors = {};

//     // Validate registrant's name
//     if (!registrationformData.name.trim()) {
//       errors.name = "Your name is required.";
//     }

//     // Validate phone
//     if (!registrationformData.phonenumber.trim()) {
//       errors.phonenumber = "Your phone number is required.";
//     } else if (!/^\d{10}$/.test(registrationformData.phonenumber)) {
//       errors.phonenumber = "Invalid phone number (10 digits).";
//     }

//     // Validate email
//     if (!registrationformData.email.trim()) {
//       errors.email = "Your email is required.";
//     } else if (!/\S+@\S+\.\S+/.test(registrationformData.email)) {
//       errors.email = "Invalid email format.";
//     }

//     // Validate passes
//     if (selectedPasses.length === 0) {
//       errors.selectedPasses = "Please select at least one pass.";
//     }

//     // Validate selected adults/kids for each pass
//     selectedPasses.forEach(item => {
//       // Check if adultsRegistered + kidsRegistered > 0 for each pass
//       if (item.adultsRegistered === 0 && item.kidsRegistered === 0) {
//         errors[`pass-${item.package.id}-counts`] = `Please specify adults or kids for "${item.package.name}".`;
//       }
//     });

//     // Guest details are no longer collected, so no validation needed for `guests` array
//     // The `members` payload will likely just contain the main registrant now.
//     // If the backend requires 'members' based on the counts, this needs further clarification.
//     // For now, removing `adultCountMismatch`, `kidCountMismatch` and `guest-` errors.


//     setFormErrors(errors);
//     return Object.keys(errors).length === 0;
//   };

//   const totalAmount = selectedPasses.reduce(
//     (sum, item) => sum + item.package.rate * item.quantity,
//     0
//   );


//   function getFormattedTimestamp() {
//     const now = new Date();
//     const year = now.getFullYear();
//     const month = (now.getMonth() + 1).toString().padStart(2, '0');
//     const day = now.getDate().toString().padStart(2, '0');
//     const hours = now.getHours().toString().padStart(2, '0');
//     const minutes = now.getMinutes().toString().padStart(2, '0');
//     const seconds = now.getSeconds().toString().padStart(2, '0');
//     const milliseconds = now.getMilliseconds().toString().padStart(3, '0');
//     return `${year}${month}${day}${hours}${minutes}${seconds}${milliseconds}`;
//   }

//   const filteredPackages = packages.filter(pkg => {
//     // If not authenticated, only show packages that are not member exclusive (member: "no") and are active ("1")
//     if (!isAuthenticated) return pkg.status === "1" && pkg.member === "no";

//     // If authenticated, filter based on whether the user is a member
//     if (isMember) {
//       return pkg.status === "1" && pkg.member === "yes"; // Show member passes if they are a member
//     } else {
//       return pkg.status === "1" && pkg.member === "no"; // Show non-member passes if they are not a member
//     }
//   });

//   const formatDateToDDMMYYYY = (dateString) => {
//     if (!dateString) return '';
//     const [year, month, day] = dateString.split('-');
//     return `${month}-${day}-${year}`;
//   };

//   const handleShowSummary = () => {
//     if (!validateForm()) {
//       setAlertMessage("Please correct the errors in the form before reviewing.");
//       setAlertVariant("danger");
//       setShowAlert(true);
//       return;
//     }
//     setShowSummaryModal(true);
//   };

//   const confirmRegistrationAndPay = async () => {
//     setShowAlert(false);
//     setLoading(true);
//     setShowSummaryModal(false); // Close summary modal

//     try {
//       const packagesPayload = selectedPasses.map(item => ({
//         id: item.package.id,
//         name: item.package.name,
//         rate: item.package.rate,
//         count: item.quantity,
//         adults: item.adultsRegistered, // Send registered adults for this package
//         kids: item.kidsRegistered,     // Send registered kids for this package
//         startdate: item.package.startdate,
//         enddate: item.package.enddate,
//         type: item.package.type,
//       }));

//       // Since guest details section is removed, the 'members' payload
//       // will now only contain the primary registrant's details.
//       // If other "members" (adults/kids from packages) need to be sent,
//       // the backend structure or user requirement needs to be re-evaluated.
//       // For now, `members` will just be the primary registrant.
//       const membersPayload = [{
//         name: registrationformData.name,
//         email: registrationformData.email,
//         phonenumber: registrationformData.phonenumber,
//         packageId: null, // No specific package ID for the main registrant
//         packageName: "Primary Registrant",
//         packageRate: 0,
//         type: "primary",
//       }];

//       const customId = getFormattedTimestamp();
//       const finalRegistrationData = {
//         ...registrationformData,
//         event: eventId,
//         amount: totalAmount,
//         packages: packagesPayload,
//         trackingid: customId,
//         members: membersPayload // Updated to only send primary registrant if no other guest info collected
//       };



//       const response = await saveeventregistration(finalRegistrationData);

//       if (response?.status === 200 && response.data) {
//         const registrationId = response.data.id;

//         // const paypalOrderRes = await axios.post("https://api.adyapeathusa.org/index.php/paypal/create_paypal_order", {
//         //   amount: totalAmount,
//         //   return_url: `${window.location.origin}/paymentsuccess?registrationId=${registrationId}`
//         // });


//         const paypalItems = selectedPasses.map(item => ({
//           name: item.package.name,
//           quantity: item.quantity.toString(), // Quantity must be a string
//           unit_amount: {
//             currency_code: "USD",
//             value: item.package.rate, // Unit amount must be a string with 2 decimal places
//           },
//           description: `Event Pass for ${item.package.name}`, // Optional description
//           sku: `EVT-${item.package.id}`, // Example SKU
//           category: "DIGITAL_GOODS", // Assuming event passes are digital goods
//         }));




//         // const paypalOrderRes = await axios.post("https://api.drsa.sdga.in/index.php/paypal/create_paypal_order", {
//         //   amount: totalAmount,
//         //   return_url: `${window.location.origin}/paymentsuccess?registrationId=${registrationId}`,
//         //   // Pass detailed purchase data to your backend
//         //   registrationId: registrationId, // Used for custom_id/invoice_id on backend
//         //   items: paypalItems, // Array of items for purchase_units
//         //   // Additional breakdown details can be added here if your backend expects them
//         //   // e.g., shipping_cost: "5.00", tax_amount: "2.50"
//         //   customId: customId,
//         // });


//         const paypalOrderRes = await axios.post("https://api.adyapeathusa.org/index.php/paypal/create_paypal_order", {
//           amount: totalAmount,
//           return_url: `${window.location.origin}/paymentsuccess?registrationId=${registrationId}`,
//           // Pass detailed purchase data to your backend
//           registrationId: registrationId, // Used for custom_id/invoice_id on backend
//           items: paypalItems, // Array of items for purchase_units
//           // Additional breakdown details can be added here if your backend expects them
//           // e.g., shipping_cost: "5.00", tax_amount: "2.50"
//           customId: customId,
//         });


//         // const paypalOrderRes = await axios.post("https://api.drsa.sdga.in/index.php/paypal/create_paypal_order", {
//         //   amount: totalAmount,
//         //   return_url: `${window.location.origin}/paymentsuccess?registrationId=${registrationId}`
//         // });

//         if (paypalOrderRes?.data?.approvalUrl && paypalOrderRes?.data?.orderID) {

//           await editregistration({
//             id: registrationId,
//             orderid: paypalOrderRes.data.orderID,
//             paymentstatus: 'PENDING',
//           });

//           window.location.href = paypalOrderRes.data.approvalUrl;
//         } else {
//           Swal.fire("Error", "Failed to initiate PayPal payment. Please try again.", "error");
//         }
//       } else {
//         const errorMessage = response?.data?.error || "Failed to save registration. Please try again.";
//         Swal.fire("Error", errorMessage, "error");
//       }
//     } catch (error) {
//       console.error("Submission error:", error);
//       Swal.fire("Error", "Something went wrong during registration!", "error");
//     } finally {
//       setLoading(false);
//     }
//   };

//   return (
//     <Container className="my-5">
//       <Card className="shadow-lg border-0 rounded-4 p-5 bg-white">
//         <h2 className="text-center text-primary mb-5 fw-bold">
//           DRSA,USA Event Registration
//         </h2>

//         {/* Authentication Modal */}
//         <Modal show={showAuthModal} onHide={() => { }} backdrop="static" keyboard={false} centered>
//           <Modal.Header>
//             <Modal.Title className="text-primary">Verify Your Access</Modal.Title>
//           </Modal.Header>
//           <Modal.Body>
//             <p className="text-muted">
//               Please enter your email to proceed. If you are a registered member, you'll gain access to exclusive member-only benefits.

//             </p>
//             <Form>
//               <Form.Group className="mb-3" controlId="authEmail">
//                 <Form.Label>Email Address</Form.Label>
//                 <Form.Control
//                   type="email"
//                   placeholder="Enter your email"
//                   value={authEmail}
//                   onChange={(e) => setAuthEmail(e.target.value)}
//                   disabled={isCodeSent || isLoadingAuth || isAuthenticated}
//                 />
//               </Form.Group>

//               {/* Show buttons only when email is entered */}
//               {authEmail && (
//                 <>
//                   {!isCodeSent && !isAuthenticated ? (
//                     <Button
//                       variant="primary"
//                       onClick={handleSendCode}
//                       disabled={isLoadingAuth}
//                       className="w-100 mb-3"
//                     >
//                       {isLoadingAuth ? (
//                         <Spinner animation="border" size="sm" className="me-2" />
//                       ) : (
//                         <span>Send Verification Code&nbsp;&nbsp;(Members Only)</span>
//                       )}
//                     </Button>
//                   ) : isCodeSent && !isAuthenticated ? (
//                     <>
//                       <Form.Group className="mb-3" controlId="authCode">
//                         <Form.Label>Verification Code</Form.Label>
//                         <Form.Control
//                           type="text"
//                           placeholder="Enter 6-digit code"
//                           value={authCode}
//                           onChange={(e) => setAuthCode(e.target.value)}
//                           maxLength={6}
//                           disabled={isLoadingAuth}
//                         />
//                         <Form.Text className="text-muted">
//                           Check your inbox for the 6-digit code.
//                         </Form.Text>
//                       </Form.Group>
//                       <Button
//                         variant="success"
//                         onClick={handleVerifyCode}
//                         disabled={isLoadingAuth || authCode.length !== 6}
//                         className="w-100 mb-3"
//                       >
//                         {isLoadingAuth ? (
//                           <Spinner animation="border" size="sm" className="me-2" />
//                         ) : (
//                           "Verify Code"
//                         )}
//                       </Button>
//                     </>
//                   ) : null}

//                   {!isAuthenticated && (
//                     <Button
//                       variant="secondary"
//                       onClick={() => {
//                         const guestEmail = authEmail;
//                         setIsAuthenticated(true);
//                         setIsMember(false);
//                         setShowAuthModal(false);
//                         setAlertMessage("Welcome Guest! You have access to general passes.");
//                         setAlertVariant("info");
//                         setShowAlert(true);
//                         setAuthEmail("");
//                         setAuthCode("");
//                         setGeneratedCode("");
//                         setIsCodeSent(false);
//                         setRegistrationformData(prev => ({
//                           ...prev,
//                           email: guestEmail
//                         }));
//                       }}
//                       className="w-100 mt-2"
//                     >
//                       Proceed as Guest
//                     </Button>
//                   )}
//                 </>
//               )}

//               {authError && <Alert variant="danger">{authError}</Alert>}
//             </Form>

//           </Modal.Body>
//         </Modal>

//         {/* Summary Modal (new) */}
//         <Modal show={showSummaryModal} onHide={() => setShowSummaryModal(false)} size="lg" centered>
//           <Modal.Header closeButton>
//             <Modal.Title className="text-primary">Review Your Registration</Modal.Title>
//           </Modal.Header>
//           <Modal.Body>
//             <h5>Event Details</h5>
//             <p><strong>Event Name:</strong> {formData.name}</p>
//             <p><strong>Dates:</strong> {formatDateToDDMMYYYY(formData.startdate)} to {formatDateToDDMMYYYY(formData.enddate)}</p>
//             <hr />

//             <h5>Your Contact Information</h5>
//             <p><strong>Name:</strong> {registrationformData.name}</p>
//             <p><strong>Email:</strong> {registrationformData.email}</p>
//             <p><strong>Phone:</strong> {registrationformData.phonenumber}</p>
//             <hr />

//             <h5>Selected Passes</h5>
//             {selectedPasses.length > 0 ? (
//               <ul className="list-group mb-3">
//                 {selectedPasses.map((item, index) => (
//                   <li key={index} className="list-group-item d-flex justify-content-between align-items-center">
//                     <div>
//                       <strong>{item.package.name}</strong> x {item.quantity}
//                       <br />
//                       <small className="text-muted">
//                         ({item.adultsRegistered} Adult(s), {item.kidsRegistered} Kid(s))
//                       </small>
//                     </div>
//                     <span>${(item.package.rate * item.quantity).toFixed(2)}</span>
//                   </li>
//                 ))}
//               </ul>
//             ) : (
//               <p>No passes selected.</p>
//             )}
//             {formErrors.selectedPasses && (
//               <Alert variant="danger" className="mt-2 text-center py-1">
//                 {formErrors.selectedPasses}
//               </Alert>
//             )}
//             {selectedPasses.some(item => formErrors[`pass-${item.package.id}-counts`]) && (
//               <Alert variant="danger" className="mt-2 text-center py-1">
//                 Please specify adults or kids for all selected passes.
//               </Alert>
//             )}
//             <hr />

//             {/* Guest Details section removed from here */}

//             <h4 className="fw-bold text-dark text-end">Total Amount: <span className="text-primary">${totalAmount.toFixed(2)}</span></h4>
//           </Modal.Body>
//           <Modal.Footer>
//             <Button variant="secondary" onClick={() => setShowSummaryModal(false)}>
//               Go Back & Edit
//             </Button>
//             <Button variant="primary" onClick={confirmRegistrationAndPay} disabled={loading}>
//               {loading ? (
//                 <Spinner animation="border" size="sm" className="me-2" />
//               ) : (
//                 "Confirm & Pay"
//               )}
//             </Button>
//           </Modal.Footer>
//         </Modal>


//         {!isAuthenticated ? (
//           <div className="text-center p-5">
//             <h4 className="text-muted">Please verify your email to access the registration form.</h4>
//           </div>
//         ) : (
//           <>
//             {showAlert && (
//               <Alert variant={alertVariant} onClose={() => setShowAlert(false)} dismissible className="mb-4">
//                 {alertMessage}
//               </Alert>
//             )}

//             <div className="mb-5 p-4 bg-light rounded-3 shadow-sm">
//               <Row className="align-items-center">
//                 <Col md={8}>
//                   <h3 className="fw-bold text-dark mb-2">{formData.name}</h3>
//                   <p className="lead text-muted">{formData.description}</p>
//                   <p className="mb-1">
//                     <strong className="text-primary me-2">🗓️ Dates:</strong> {formatDateToDDMMYYYY(formData.startdate)} to {formatDateToDDMMYYYY(formData.enddate)}
//                   </p>
//                   <p className="mb-0">
//                     <strong className="text-primary me-2">⏰ Time:</strong> {formData.starttime} to {formData.endtime} PT
//                   </p>
//                 </Col>
//                 <Col md={4} className="text-end">
//                   {/* <Badge bg={formData.registrationallowed === "1" ? "success" : "secondary"} className="p-3 fs-6 rounded-pill">
//                     {formData.registrationallowed === "1" ? "Registration Open" : "Registration Closed"}
//                   </Badge> */}
//                   <h4>{formData.registrationallowed === "1" ? "Registration Open" : "Registration Closed"}</h4>
//                 </Col>
//               </Row>
//             </div>

//             <div className="mt-5 text-center">
//               <Button
//                 variant="primary"
//                 onClick={handleShowSummary} // Trigger summary modal first
//                 size="lg"
//                 className="px-5 py-3 rounded-pill fw-bold"
//                 disabled={loading}
//               >
//                 {loading ? (
//                   <Spinner animation="border" size="sm" className="me-2" />
//                 ) : (
//                   "Review & Proceed to Payment"
//                 )}
//               </Button>
//             </div>

//             <h4 className="text-info mb-4 fw-bold">
//               <span className="me-2">✨</span>Choose Your Passes
//             </h4>
//             <div className="d-md-block table-responsive">
//               <table className="mb-3 table-bordered">
//                 <thead style={{ backgroundColor: '#0d6efd', color: 'white', textAlign: 'left' }}>
//                   <tr>
//                     <th style={{ padding: '10px' }}>Package Name</th>
//                     <th style={{ padding: '10px' }}>Date(s)</th>
//                     <th style={{ padding: '10px' }}>Rate</th>
//                     <th style={{ padding: '10px' }}>Capacity</th>
//                     <th style={{ padding: '10px' }}>Eligibility</th>
//                     <th style={{ padding: '10px' }}>Quantity</th>
//                     <th style={{ padding: '10px' }}>Adults</th>
//                     <th style={{ padding: '10px' }}>Kids</th>
//                   </tr>
//                 </thead>
//                 <tbody>
//                   {filteredPackages.map((pkg) => {
//                     const selectedItem = selectedPasses.find(item => item.package.id === pkg.id);
//                     const quantity = selectedItem ? selectedItem.quantity : 0;
//                     const isDisabled = pkg.status !== "1";

//                     return (
//                       <tr key={pkg.id} className={isDisabled ? "opacity-50" : ""}>
//                         <td className="fw-bold" style={{ padding: '10px' }}>{pkg.name}</td>
//                         <td className="text-danger fw-bold" style={{ padding: '10px' }}>
//                           {pkg.startdate === pkg.enddate
//                             ? `${pkg.startdate} (${pkg.type})`
//                             : `${pkg.startdate} to ${pkg.enddate} (${pkg.type})`}
//                         </td>
//                         <td className="text-primary fw-bold" style={{ padding: '10px' }}>${pkg.rate}</td>
//                         <td className="text-muted" style={{ padding: '10px' }}>
//                           {pkg.adults} {pkg.adults === 1 ? "adult" : "adults"} + {pkg.kids} {pkg.kids === 1 ? "kid" : "kids"}
//                         </td>
//                         <td style={{ padding: '10px' }}>
//                           {pkg.member === "yes" ? "✅ Member Exclusive" : "🤝 Open to All"}
//                         </td>
//                         <td style={{ padding: '10px' }}>
//                           <InputGroup>
//                             <Button
//                               variant="danger"
//                               size="md"
//                               onClick={() => handlePassQuantityChange(pkg.id, -1)}
//                               disabled={isDisabled || quantity === 0}
//                             >
//                               -
//                             </Button>
//                             <InputGroup.Text className="mx-2 px-2 fw-bold">{quantity}</InputGroup.Text>
//                             <Button
//                               variant="primary"
//                               size="md"
//                               onClick={() => handlePassQuantityChange(pkg.id, 1)}
//                               disabled={isDisabled}
//                             >
//                               +
//                             </Button>
//                           </InputGroup>
//                         </td>
//                         <td style={{ padding: '10px' }}>
//                           {quantity > 0 && (
//                             <Form.Group controlId={`adults-${pkg.id}`}>
//                               <Form.Control
//                                 type="number"
//                                 min="0"
//                                 max={pkg.adults * quantity}
//                                 value={selectedItem.adultsRegistered}
//                                 onChange={(e) => handleRegisteredGuestCountChange(pkg.id, 'adults', e.target.value)}
//                                 className={`form-control-sm ${formErrors[`pass-${pkg.id}-counts`] ? 'is-invalid' : ''}`}
//                               />
//                             </Form.Group>
//                           )}
//                         </td>
//                         <td style={{ padding: '10px' }}>
//                           {quantity > 0 && (
//                             <Form.Group controlId={`kids-${pkg.id}`}>
//                               <Form.Control
//                                 type="number"
//                                 min="0"
//                                 max={pkg.kids * quantity}
//                                 value={selectedItem.kidsRegistered}
//                                 onChange={(e) => handleRegisteredGuestCountChange(pkg.id, 'kids', e.target.value)}
//                                 className={`form-control-sm ${formErrors[`pass-${pkg.id}-counts`] ? 'is-invalid' : ''}`}
//                               />
//                             </Form.Group>
//                           )}
//                         </td>
//                       </tr>
//                     );
//                   })}
//                 </tbody>
//               </table>
//             </div>


//             {formErrors.selectedPasses && (
//               <Alert variant="danger" className="mt-2 text-center">
//                 {formErrors.selectedPasses}
//               </Alert>
//             )}
//             {selectedPasses.some(item => formErrors[`pass-${item.package.id}-counts`]) && (
//               <Alert variant="danger" className="mt-2 text-center">
//                 Please specify adults or kids for all selected passes.
//               </Alert>
//             )}


//             <h4 className="text-info mt-4 mb-4 fw-bold">
//               <span className="me-2">📞</span>Your Contact Information
//             </h4>
//             <div className="mb-3 p-3 border rounded-3 bg-light">
//               <Row className="g-3">
//                 <Col md={4}>
//                   <Form.Group controlId="registrantName">
//                     <Form.Label>Name *</Form.Label>
//                     <Form.Control
//                       type="text"
//                       name="name"
//                       value={registrationformData.name}
//                       onChange={handleRegistrantInfoChange}
//                       className={`rounded-3 p-3 ${formErrors.name ? 'is-invalid' : ''}`}
//                       required
//                     />
//                     <Form.Control.Feedback type="invalid">
//                       {formErrors.name}
//                     </Form.Control.Feedback>
//                   </Form.Group>
//                 </Col>
//                 <Col md={4}>
//                   <Form.Group controlId="registrantEmail">
//                     <Form.Label>Email Address</Form.Label>
//                     <Form.Control
//                       type="email"
//                       name="email"
//                       value={registrationformData.email}
//                       onChange={handleRegistrantInfoChange}
//                       disabled={true}
//                       className={`rounded-3 p-3 ${formErrors.email ? 'is-invalid' : ''}`}
//                     />
//                     <Form.Control.Feedback type="invalid">
//                       {formErrors.email}
//                     </Form.Control.Feedback>
//                   </Form.Group>
//                 </Col>
//                 <Col md={4}>
//                   <Form.Group controlId="registrantPhoneNumber">
//                     <Form.Label>Phone Number</Form.Label>
//                     <Form.Control
//                       type="tel"
//                       name="phonenumber"
//                       placeholder="Your 10-digit phone number"
//                       value={registrationformData.phonenumber}
//                       onChange={handleRegistrantInfoChange}
//                       className={`rounded-3 p-3 ${formErrors.phonenumber ? 'is-invalid' : ''}`}
//                     />
//                     <Form.Control.Feedback type="invalid">
//                       {formErrors.phonenumber}
//                     </Form.Control.Feedback>
//                   </Form.Group>
//                 </Col>
//               </Row>
//             </div>

//             <hr className="my-5" />

//             <Row className="align-items-center">
//               <Col md={6}>
//                 <h4 className="fw-bold text-dark mb-0">Total Amount:</h4>
//               </Col>
//               <Col md={6} className="text-end">
//                 <h3 className="fw-bold text-primary mb-0">${totalAmount.toFixed(2)}</h3>
//               </Col>
//             </Row>

//             <div className="mt-5 text-center">
//               <Button
//                 variant="primary"
//                 onClick={handleShowSummary} // Trigger summary modal first
//                 size="lg"
//                 className="px-5 py-3 rounded-pill fw-bold"
//                 disabled={loading}
//               >
//                 {loading ? (
//                   <Spinner animation="border" size="sm" className="me-2" />
//                 ) : (
//                   "Review & Proceed to Payment"
//                 )}
//               </Button>
//             </div>
//           </>
//         )}
//       </Card>
//     </Container>
//   );
// }



import React, { useState, useEffect } from "react";
import {
  Container,
  Row,
  Col,
  Form,
  Button,
  Card,
  Badge,
  Alert,
  InputGroup,
  Modal,
  Spinner,
} from "react-bootstrap";
import "bootstrap/dist/css/bootstrap.min.css";
import Swal from "sweetalert2";
import { sendcode, getByEventId, getpackagebyevent, saveeventregistration, editregistration } from "../store/slices/userSlice";
import { useSearchParams } from "react-router-dom";
import axios from "axios";

export default function EventRegistrationPage() {
  const [searchParams] = useSearchParams();
  const eventId = searchParams.get("id") || "";
  const [packages, setPackages] = useState([]);
  const [loading, setLoading] = useState(false);

  const [registrationformData, setRegistrationformData] = useState({
    id: 0,
    event: "",
    phonenumber: "",
    email: "",
    amount: 0,
    packages: [],
    members: [],
    status: "1",
    name: "",
    adults: 0,
    kids: 0,
  });

  const [formData, setFormData] = useState({
    id: 0,
    name: "",
    startdate: "",
    enddate: "",
    starttime: "",
    endtime: "",
    description: "",
    registrationallowed: "",
    status: "",
  });

  const [selectedPasses, setSelectedPasses] = useState([]);
  const [guests, setGuests] = useState([]);
  const [formErrors, setFormErrors] = useState({});
  const [showAlert, setShowAlert] = useState(false);
  const [alertMessage, setAlertMessage] = useState("");
  const [alertVariant, setAlertVariant] = useState("danger");

  const [showAuthModal, setShowAuthModal] = useState(true);
  const [authEmail, setAuthEmail] = useState("");
  const [authCode, setAuthCode] = useState("");
  const [generatedCode, setGeneratedCode] = useState("");
  const [isCodeSent, setIsCodeSent] = useState(false);
  const [authError, setAuthError] = useState("");
  const [isAuthenticated, setIsAuthenticated] = useState(false);
  const [isMember, setIsMember] = useState(false);
  const [isLoadingAuth, setIsLoadingAuth] = useState(false);
  const [name, setName] = useState("");

  const [showSummaryModal, setShowSummaryModal] = useState(false);

  useEffect(() => {
    try {
      const totalAdultsRegistered = selectedPasses.reduce(
        (sum, item) => sum + item.adultsRegistered,
        0
      );
      const totalKidsRegistered = selectedPasses.reduce(
        (sum, item) => sum + item.kidsRegistered,
        0
      );

      setRegistrationformData((prev) => ({
        ...prev,
        adults: totalAdultsRegistered,
        kids: totalKidsRegistered,
      }));
    } catch (error) {
      console.error("Error in useEffect for total adults/kids:", error);
    }
  }, [selectedPasses]);

  useEffect(() => {
    try {
      if (eventId) {
        fetchEventDetails(eventId);
      }
    } catch (error) {
      console.error("Error in useEffect for fetching event details:", error);
    }
  }, [eventId]);

  const fetchEventDetails = async (id) => {
    setLoading(true);
    try {
      const eventResponse = await getByEventId(id);
      if (eventResponse?.status === 200 && eventResponse.data) {
        setFormData((prev) => ({
          ...prev,
          ...eventResponse.data,
        }));
      } else {
        Swal.fire("Error", "Error fetching event details!", "error");
      }

      const packagesResponse = await getpackagebyevent(id);
      if (packagesResponse?.status === 200 && Array.isArray(packagesResponse.data)) {
        const mappedPackages = packagesResponse.data.map(pkg => ({
          id: pkg.id,
          name: pkg.name,
          rate: pkg.rate,
          member: pkg.member,
          status: pkg.status,
          adults: pkg.adults || 0,
          kids: pkg.kids || 0,
          startdate: pkg.formattedstartdate,
          enddate: pkg.formattedenddate,
          type: pkg.type,
        }));

        setPackages(mappedPackages);
      } else {
        Swal.fire("Error", "Error fetching package details!", "error");
        setPackages([]);
      }
    } catch (error) {
      console.error("Error fetching event or package data:", error);
      Swal.fire("Error", "Error fetching event or package data!", "error");
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    setGuests([]);
  }, [selectedPasses]);

  const handleSendCode = async () => {
    setAuthError("");
    setIsLoadingAuth(true);

    if (!authEmail || !/\S+@\S+\.\S/.test(authEmail)) {
      setAuthError("Please enter a valid email address.");
      setIsLoadingAuth(false);
      return;
    }

    const randomCode = Math.floor(100000 + Math.random() * 900000).toString();
    setGeneratedCode(randomCode);

    try {
      const response = await sendcode(authEmail.toLowerCase(), randomCode);

      if (response?.status === 200 && response.data) {
        Swal.fire("Success", "Verification code sent to your email!", "success");
        setName(response.data[0]?.name || "");
        setIsCodeSent(true);
      } else if (response?.data?.error === "Mail Not Registered") {
        Swal.fire("Info", "Email not registered. Proceeding as a guest.", "info");
        setIsAuthenticated(true);
        setIsMember(false);
        setShowAuthModal(false);
        setAlertMessage("Welcome Guest! You have access to general passes.");
        setAlertVariant("info");
        setShowAlert(true);
        setRegistrationformData(prev => ({
          ...prev,
          email: authEmail
        }));
      } else {
        const errorMessage = response?.data?.error || "Failed to send code. Please try again.";
        Swal.fire("Error", errorMessage, "error");
        setAuthError(errorMessage);
        setIsCodeSent(false);
      }
    } catch (error) {
      console.error("Error sending code:", error);
      setAuthError("Network error. Please try again later.");
      Swal.fire("Error", "Network error. Please try again later.", "error");
      setIsCodeSent(false);
    }
    finally {
      setIsLoadingAuth(false);
    }
  };

  const handleVerifyCode = async () => {
    setAuthError("");
    setIsLoadingAuth(true);

    if (!authCode || authCode.length !== 6) {
      setAuthError("Please enter the 6-digit code.");
      setIsLoadingAuth(false);
      return;
    }

    try {
      await new Promise(resolve => setTimeout(resolve, 1500));

      if (authCode === generatedCode) {
        setIsAuthenticated(true);
        setIsMember(true);
        setShowAuthModal(false);
        setAlertMessage(`Welcome ${name || 'Member'}!`);
        setAlertVariant("success");
        setShowAlert(true);
        setRegistrationformData(prev => ({
          ...prev,
          email: authEmail,
          name: name || ''
        }));
      } else {
        setAuthError("Invalid code. Please try again.");
      }
    } catch (error) {
      setAuthError("Network error during verification. Please try again.");
    } finally {
      setIsLoadingAuth(false);
    }
  };

  const handleRegistrantInfoChange = (e) => {
    try {
      const { name, value } = e.target;
      setRegistrationformData((prev) => ({
        ...prev,
        [name]: value,
      }));
      if (formErrors[name] && value.trim()) {
        const newErrors = { ...formErrors };
        delete newErrors[name];
        setFormErrors(newErrors);
      }
    } catch (error) {
      console.error("Error handling registrant info change:", error);
    }
  };
  const handlePassQuantityChange = (pkgId, change) => {
    try {
      setSelectedPasses((prevSelected) => {
        const existingPassIndex = prevSelected.findIndex(
          (item) => item.package.id === pkgId
        );
        const pkgToModify = packages.find((pkg) => pkg.id === pkgId);

        if (!pkgToModify || pkgToModify.status !== "1") {
          setAlertMessage(
            `The "${pkgToModify?.name || "selected package"}" is currently unavailable.`
          );
          setAlertVariant("warning");
          setShowAlert(true);
          return prevSelected;
        }

        if (pkgToModify.member === "yes" && !isMember) {
          setAlertMessage(
            `The "${pkgToModify.name}" is for members only. Please register or verify as a member.`
          );
          setAlertVariant("warning");
          setShowAlert(true);
          return prevSelected;
        }

        if (existingPassIndex !== -1) {
          const newSelected = [...prevSelected];
          const currentItem = newSelected[existingPassIndex];
          const newQuantity = currentItem.quantity + change;

          if (newQuantity <= 0) {
            return newSelected.filter((item) => item.package.id !== pkgId);
          } else {
            const maxAdultsForNewQty = newQuantity * pkgToModify.adults;
            const maxKidsForNewQty = newQuantity * pkgToModify.kids;

            newSelected[existingPassIndex] = {
              ...currentItem,
              quantity: newQuantity,
              adultsRegistered:
                change > 0
                  ? maxAdultsForNewQty
                  : Math.min(currentItem.adultsRegistered, maxAdultsForNewQty),
              kidsRegistered:
                change > 0
                  ? maxKidsForNewQty
                  : Math.min(currentItem.kidsRegistered, maxKidsForNewQty),
            };
            return newSelected;
          }
        } else if (change > 0) {
          return [
            ...prevSelected,
            {
              package: pkgToModify,
              quantity: 1,
              adultsRegistered: pkgToModify.adults,
              kidsRegistered: pkgToModify.kids,
            },
          ];
        }
        return prevSelected;
      });
      setFormErrors((prevErrors) => {
        const newErrors = { ...prevErrors };
        delete newErrors.selectedPasses;
        return newErrors;
      });
    } catch (error) {
      console.error("Error handling pass quantity change:", error);
    }
  };


  const handleRegisteredGuestCountChange = (pkgId, type, value) => {
    try {
      setSelectedPasses((prevSelected) => {
        return prevSelected.map((item) => {
          if (item.package.id === pkgId) {
            const maxAllowed =
              item.quantity *
              (type === "adults" ? item.package.adults : item.package.kids);
            const newValue = Math.max(0, Math.min(parseInt(value) || 0, maxAllowed));
            return {
              ...item,
              [type === "adults" ? "adultsRegistered" : "kidsRegistered"]: newValue,
            };
          }
          return item;
        });
      });
    } catch (error) {
      console.error("Error handling registered guest count change:", error);
    }
  };

  const validateForm = () => {
    try {
      const errors = {};

      if (!registrationformData.name.trim()) {
        errors.name = "Your name is required.";
      }

      if (!registrationformData.phonenumber.trim()) {
        errors.phonenumber = "Your phone number is required.";
      } else if (!/^\d{10}$/.test(registrationformData.phonenumber)) {
        errors.phonenumber = "Invalid phone number (10 digits).";
      }

      if (!registrationformData.email.trim()) {
        errors.email = "Your email is required.";
      } else if (!/\S+@\S+\.\S+/.test(registrationformData.email)) {
        errors.email = "Invalid email format.";
      }

      if (selectedPasses.length === 0) {
        errors.selectedPasses = "Please select at least one pass.";
      }

      selectedPasses.forEach((item) => {
        if (item.adultsRegistered === 0 && item.kidsRegistered === 0) {
          errors[
            `pass-${item.package.id}-counts`
          ] = `Please specify adults or kids for "${item.package.name}".`;
        }
      });

      setFormErrors(errors);
      return Object.keys(errors).length === 0;
    } catch (error) {
      console.error("Error validating form:", error);
      return false;
    }
  };

  const totalAmount = selectedPasses.reduce(
    (sum, item) => sum + item.package.rate * item.quantity,
    0
  );

  function getFormattedTimestamp() {
    try {
      const now = new Date();
      const year = now.getFullYear();
      const month = (now.getMonth() + 1).toString().padStart(2, "0");
      const day = now.getDate().toString().padStart(2, "0");
      const hours = now.getHours().toString().padStart(2, "0");
      const minutes = now.getMinutes().toString().padStart(2, "0");
      const seconds = now.getSeconds().toString().padStart(2, "0");
      const milliseconds = now.getMilliseconds().toString().padStart(3, "0");
      return `${year}${month}${day}${hours}${minutes}${seconds}${milliseconds}`;
    } catch (error) {
      console.error("Error getting formatted timestamp:", error);
      return "";
    }
  }

  const filteredPackages = packages.filter((pkg) => {
    try {
      if (!isAuthenticated) return pkg.status === "1" && pkg.member === "no";

      if (isMember) {
        return pkg.status === "1" && pkg.member === "yes";
      } else {
        return pkg.status === "1" && pkg.member === "no";
      }
    } catch (error) {
      console.error("Error filtering packages:", error);
      return false;
    }
  });

  const formatDateToDDMMYYYY = (dateString) => {
    try {
      if (!dateString) return "";
      const [year, month, day] = dateString.split("-");
      return `${month}-${day}-${year}`;
    } catch (error) {
      console.error("Error formatting date:", error);
      return "";
    }
  };

  const handleShowSummary = () => {
    try {
      if (!validateForm()) {
        setAlertMessage("Please correct the errors in the form before reviewing.");
        setAlertVariant("danger");
        setShowAlert(true);
        return;
      }
      setShowSummaryModal(true);
    } catch (error) {
      console.error("Error showing summary:", error);
    }
  };

  const confirmRegistrationAndPay = async () => {
    setShowAlert(false);
    setLoading(true);
    setShowSummaryModal(false);

    try {

      if ('caches' in window) {
        const cacheName = 'paypal-api-cache'; 
        await caches.delete(cacheName);
        console.log('PayPal API cache cleared.');
      }



      const packagesPayload = selectedPasses.map(item => ({
        id: item.package.id,
        name: item.package.name,
        rate: item.package.rate,
        count: item.quantity,
        adults: item.adultsRegistered,
        kids: item.kidsRegistered,
        startdate: item.package.startdate,
        enddate: item.package.enddate,
        type: item.package.type,
      }));

      const membersPayload = [{
        name: registrationformData.name,
        email: registrationformData.email,
        phonenumber: registrationformData.phonenumber,
        packageId: null,
        packageName: "Primary Registrant",
        packageRate: 0,
        type: "primary",
      }];

      const customId = getFormattedTimestamp();
      const finalRegistrationData = {
        ...registrationformData,
        event: eventId,
        amount: totalAmount,
        packages: packagesPayload,
        trackingid: customId,
        members: membersPayload
      };

      

      const response = await saveeventregistration(finalRegistrationData);

      if (response?.status === 200 && response.data) {
        const registrationId = response.data.id;

        const paypalItems = selectedPasses.map(item => ({
          name: item.package.name,
          quantity: item.quantity.toString(),
          unit_amount: {
            currency_code: "USD",
            value: item.package.rate,
          },
          description: `Event Pass for ${item.package.name}`,
          sku: `EVT-${item.package.id}`,
          category: "DIGITAL_GOODS",
        }));

        const paypalOrderRes = await axios.post("https://api.adyapeathusa.org/index.php/paypal/create_paypal_order", {
          amount: totalAmount,
          return_url: `${window.location.origin}/paymentsuccess?registrationId=${registrationId}`,
          registrationId: registrationId,
          items: paypalItems,
          customId: customId,
        });


        // const paypalOrderRes = await axios.post("https://api.drsa.sdga.in/index.php/paypal/create_paypal_order", {
        //   amount: totalAmount,
        //   return_url: `${window.location.origin}/paymentsuccess?registrationId=${registrationId}`,
        //   registrationId: registrationId,
        //   items: paypalItems,
        //   customId: customId,
        // });

        if (paypalOrderRes?.data?.approvalUrl && paypalOrderRes?.data?.orderID) {
          await editregistration({
            id: registrationId,
            orderid: paypalOrderRes.data.orderID,
            paymentstatus: 'PENDING',
          });
          window.location.href = paypalOrderRes.data.approvalUrl;
        } else {
          Swal.fire("Error", "Failed to initiate PayPal payment. Please try again.", "error");
        }
      } else {
        const errorMessage = response?.data?.error || "Failed to save registration. Please try again.";
        Swal.fire("Error", errorMessage, "error");
      }
    } catch (error) {
      console.error("Submission error:", error);
      Swal.fire("Error", "Something went wrong during registration!", "error");
    } finally {
      setLoading(false);
    }
  };

  const isRegistrationClosed = formData.registrationallowed !== "1" || filteredPackages.length === 0;

  return (
    <Container className="my-5">
      <Card className="shadow-lg border-0 rounded-4 p-5 bg-white">
        <h2 className="text-center text-primary mb-5 fw-bold">
          DRSA,USA Event Registration
        </h2>

        <Modal show={showAuthModal} onHide={() => { }} backdrop="static" keyboard={false} centered>
          <Modal.Header>
            <Modal.Title className="text-primary">Verify Your Access</Modal.Title>
          </Modal.Header>
          <Modal.Body>
            <p className="text-muted">
              Please enter your email to proceed. If you are a registered member, you'll gain access to exclusive member-only benefits.
            </p>
            <Form>
              <Form.Group className="mb-3" controlId="authEmail">
                <Form.Label>Email Address</Form.Label>
                <Form.Control
                  type="email"
                  placeholder="Enter your email"
                  value={authEmail}
                  onChange={(e) => setAuthEmail(e.target.value)}
                  disabled={isCodeSent || isLoadingAuth || isAuthenticated}
                />
              </Form.Group>

              {authEmail && (
                <>
                  {!isCodeSent && !isAuthenticated ? (
                    <Button
                      variant="primary"
                      onClick={handleSendCode}
                      disabled={isLoadingAuth}
                      className="w-100 mb-3"
                    >
                      {isLoadingAuth ? (
                        <Spinner animation="border" size="sm" className="me-2" />
                      ) : (
                        <span>Send Verification Code&nbsp;&nbsp;(Members Only)</span>
                      )}
                    </Button>
                  ) : isCodeSent && !isAuthenticated ? (
                    <>
                      <Form.Group className="mb-3" controlId="authCode">
                        <Form.Label>Verification Code</Form.Label>
                        <Form.Control
                          type="text"
                          placeholder="Enter 6-digit code"
                          value={authCode}
                          onChange={(e) => setAuthCode(e.target.value)}
                          maxLength={6}
                          disabled={isLoadingAuth}
                        />
                        <Form.Text className="text-muted">
                          Check your inbox for the 6-digit code.
                        </Form.Text>
                      </Form.Group>
                      <Button
                        variant="success"
                        onClick={handleVerifyCode}
                        disabled={isLoadingAuth || authCode.length !== 6}
                        className="w-100 mb-3"
                      >
                        {isLoadingAuth ? (
                          <Spinner animation="border" size="sm" className="me-2" />
                        ) : (
                          "Verify Code"
                        )}
                      </Button>
                    </>
                  ) : null}

                  {!isAuthenticated && (
                    <Button
                      variant="secondary"
                      onClick={() => {
                        const guestEmail = authEmail;
                        setIsAuthenticated(true);
                        setIsMember(false);
                        setShowAuthModal(false);
                        setAlertMessage("Welcome Guest! You have access to general passes.");
                        setAlertVariant("info");
                        setShowAlert(true);
                        setAuthEmail("");
                        setAuthCode("");
                        setGeneratedCode("");
                        setIsCodeSent(false);
                        setRegistrationformData(prev => ({
                          ...prev,
                          email: guestEmail
                        }));
                      }}
                      className="w-100 mt-2"
                    >
                      Proceed as Guest
                    </Button>
                  )}
                </>
              )}
              {authError && <Alert variant="danger">{authError}</Alert>}
            </Form>
          </Modal.Body>
        </Modal>

        <Modal show={showSummaryModal} onHide={() => setShowSummaryModal(false)} size="lg" centered>
          <Modal.Header closeButton>
            <Modal.Title className="text-primary">Review Your Registration</Modal.Title>
          </Modal.Header>
          <Modal.Body>
            <h5>Event Details</h5>
            <p><strong>Event Name:</strong> {formData.name}</p>
            <p><strong>Dates:</strong> {formatDateToDDMMYYYY(formData.startdate)} to {formatDateToDDMMYYYY(formData.enddate)}</p>
            <hr />

            <h5>Your Contact Information</h5>
            <p><strong>Name:</strong> {registrationformData.name}</p>
            <p><strong>Email:</strong> {registrationformData.email}</p>
            <p><strong>Phone:</strong> {registrationformData.phonenumber}</p>
            <hr />

            <h5>Selected Passes</h5>
            {selectedPasses.length > 0 ? (
              <ul className="list-group mb-3">
                {selectedPasses.map((item, index) => (
                  <li key={index} className="list-group-item d-flex justify-content-between align-items-center">
                    <div>
                      <strong>{item.package.name}</strong> x {item.quantity}
                      <br />
                      <small className="text-muted">
                        ({item.adultsRegistered} Adult(s), {item.kidsRegistered} Kid(s))
                      </small>
                    </div>
                    <span>${(item.package.rate * item.quantity).toFixed(2)}</span>
                  </li>
                ))}
              </ul>
            ) : (
              <p>No passes selected.</p>
            )}
            <hr />

            <h4 className="fw-bold text-dark text-end">Total Amount: <span className="text-primary">${totalAmount.toFixed(2)}</span></h4>
          </Modal.Body>
          <Modal.Footer>
            <Button variant="secondary" onClick={() => setShowSummaryModal(false)}>
              Go Back & Edit
            </Button>
            <Button variant="primary" onClick={confirmRegistrationAndPay} disabled={loading}>
              {loading ? (
                <Spinner animation="border" size="sm" className="me-2" />
              ) : (
                "Confirm & Pay"
              )}
            </Button>
          </Modal.Footer>
        </Modal>


        {!isAuthenticated ? (
          <div className="text-center p-5">
            <h4 className="text-muted">Please verify your email to access the registration form.</h4>
          </div>
        ) : isRegistrationClosed ? (
          <div className="text-center p-5">
            <h4 className="text-muted">Registration for this event is currently closed.</h4>
          </div>
        ) : (
          <>
            {showAlert && (
              <Alert variant={alertVariant} onClose={() => setShowAlert(false)} dismissible className="mb-4">
                {alertMessage}
              </Alert>
            )}
            
            {Object.keys(formErrors).length > 0 && (
              <Alert variant="danger" className="mb-4">
                <h5 className="alert-heading">Please correct the following errors:</h5>
                <ul>
                  {Object.values(formErrors).map((error, index) => (
                    <li key={index}>{error}</li>
                  ))}
                </ul>
              </Alert>
            )}

            <div className="mb-5 p-4 bg-light rounded-3 shadow-sm">
              <Row className="align-items-center">
                <Col md={8}>
                  <h3 className="fw-bold text-dark mb-2">{formData.name}</h3>
                  <p className="lead text-muted">{formData.description}</p>
                  <p className="mb-1">
                    <strong className="text-primary me-2">🗓️ Dates:</strong> {formatDateToDDMMYYYY(formData.startdate)} to {formatDateToDDMMYYYY(formData.enddate)}
                  </p>
                  <p className="mb-0">
                    <strong className="text-primary me-2">⏰ Time:</strong> {formData.starttime} to {formData.endtime} PT
                  </p>
                </Col>
                <Col md={4} className="text-end">
                  <h4>Registration Open</h4>
                </Col>
              </Row>
            </div>
            
            <h4 className="text-info mt-4 mb-4 fw-bold">
              <span className="me-2">📞</span>Your Contact Information
            </h4>
            <div className="mb-3 p-3 border rounded-3 bg-light">
              <Row className="g-3">
                <Col md={4}>
                  <Form.Group controlId="registrantName">
                    <Form.Label>Name *</Form.Label>
                    <Form.Control
                      type="text"
                      name="name"
                      value={registrationformData.name}
                      onChange={handleRegistrantInfoChange}
                      className={`rounded-3 p-3 ${formErrors.name ? 'is-invalid' : ''}`}
                      required
                    />
                  </Form.Group>
                </Col>
                <Col md={4}>
                  <Form.Group controlId="registrantEmail">
                    <Form.Label>Email Address</Form.Label>
                    <Form.Control
                      type="email"
                      name="email"
                      value={registrationformData.email}
                      onChange={handleRegistrantInfoChange}
                      disabled={true}
                      className={`rounded-3 p-3 ${formErrors.email ? 'is-invalid' : ''}`}
                    />
                  </Form.Group>
                </Col>
                <Col md={4}>
                  <Form.Group controlId="registrantPhoneNumber">
                    <Form.Label>Phone Number</Form.Label>
                    <Form.Control
                      type="tel"
                      name="phonenumber"
                      placeholder="Your 10-digit phone number"
                      value={registrationformData.phonenumber}
                      onChange={handleRegistrantInfoChange}
                      className={`rounded-3 p-3 ${formErrors.phonenumber ? 'is-invalid' : ''}`}
                    />
                  </Form.Group>
                </Col>
              </Row>
            </div>
            
            <h4 className="text-info mb-4 fw-bold">
              <span className="me-2">✨</span>Choose Your Passes
            </h4>
            <div className="d-md-block table-responsive">
              <table className="mb-3 table-bordered">
                <thead style={{ backgroundColor: '#0d6efd', color: 'white', textAlign: 'left' }}>
                  <tr>
                    <th style={{ padding: '10px' }}>Package Name</th>
                    <th style={{ padding: '10px' }}>Date(s)</th>
                    <th style={{ padding: '10px' }}>Rate</th>
                    <th style={{ padding: '10px' }}>Capacity</th>
                    <th style={{ padding: '10px' }}>Eligibility</th>
                    <th style={{ padding: '10px' }}>Quantity</th>
                    <th style={{ padding: '10px' }}>Adults</th>
                    <th style={{ padding: '10px' }}>Kids</th>
                  </tr>
                </thead>
                <tbody>
                  {filteredPackages.map((pkg) => {
                    const selectedItem = selectedPasses.find(item => item.package.id === pkg.id);
                    const quantity = selectedItem ? selectedItem.quantity : 0;
                    const isDisabled = pkg.status !== "1";

                    return (
                      <tr key={pkg.id} className={isDisabled ? "opacity-50" : ""}>
                        <td className="fw-bold" style={{ padding: '10px' }}>{pkg.name}</td>
                        <td className="text-danger fw-bold" style={{ padding: '10px' }}>
                          {pkg.startdate === pkg.enddate
                            ? `${pkg.startdate} (${pkg.type})`
                            : `${pkg.startdate} to ${pkg.enddate} (${pkg.type})`}
                        </td>
                        <td className="text-primary fw-bold" style={{ padding: '10px' }}>${pkg.rate}</td>
                        <td className="text-muted" style={{ padding: '10px' }}>
                          {pkg.adults} {pkg.adults === 1 ? "adult" : "adults"} + {pkg.kids} {pkg.kids === 1 ? "kid" : "kids"}
                        </td>
                        <td style={{ padding: '10px' }}>
                          {pkg.member === "yes" ? "✅ Member Exclusive" : "🤝 Open to All"}
                        </td>
                        <td style={{ padding: '10px' }}>
                          <InputGroup>
                            <Button
                              variant="danger"
                              size="md"
                              onClick={() => handlePassQuantityChange(pkg.id, -1)}
                              disabled={isDisabled || quantity === 0}
                            >
                              -
                            </Button>
                            <InputGroup.Text className="mx-2 px-2 fw-bold">{quantity}</InputGroup.Text>
                            <Button
                              variant="primary"
                              size="md"
                              onClick={() => handlePassQuantityChange(pkg.id, 1)}
                              disabled={isDisabled}
                            >
                              +
                            </Button>
                          </InputGroup>
                        </td>
                        <td style={{ padding: '10px' }}>
                          {quantity > 0 && (
                            <Form.Group controlId={`adults-${pkg.id}`}>
                              <Form.Control
                                type="number"
                                min="0"
                                max={pkg.adults * quantity}
                                value={selectedItem?.adultsRegistered || 0}
                                onChange={(e) => handleRegisteredGuestCountChange(pkg.id, 'adults', e.target.value)}
                                className={`form-control-sm ${formErrors[`pass-${pkg.id}-counts`] ? 'is-invalid' : ''}`}
                              />
                            </Form.Group>
                          )}
                        </td>
                        <td style={{ padding: '10px' }}>
                          {quantity > 0 && (
                            <Form.Group controlId={`kids-${pkg.id}`}>
                              <Form.Control
                                type="number"
                                min="0"
                                max={pkg.kids * quantity}
                                value={selectedItem?.kidsRegistered || 0}
                                onChange={(e) => handleRegisteredGuestCountChange(pkg.id, 'kids', e.target.value)}
                                className={`form-control-sm ${formErrors[`pass-${pkg.id}-counts`] ? 'is-invalid' : ''}`}
                              />
                            </Form.Group>
                          )}
                        </td>
                      </tr>
                    );
                  })}
                </tbody>
              </table>
            </div>

            <hr className="my-5" />

            <Row className="align-items-center">
              <Col md={6}>
                <h4 className="fw-bold text-dark mb-0">Total Amount:</h4>
              </Col>
              <Col md={6} className="text-end">
                <h3 className="fw-bold text-primary mb-0">${totalAmount.toFixed(2)}</h3>
              </Col>
            </Row>


            {Object.keys(formErrors).length > 0 && (
              <Alert variant="danger" className="mb-4">
                <h5 className="alert-heading">Please correct the following errors:</h5>
                <ul>
                  {Object.values(formErrors).map((error, index) => (
                    <li key={index}>{error}</li>
                  ))}
                </ul>
              </Alert>
            )}


            <div className="mt-5 text-center">
              <Button
                variant="primary"
                onClick={handleShowSummary}
                size="lg"
                className="px-5 py-3 rounded-pill fw-bold"
                disabled={loading}
              >
                {loading ? (
                  <Spinner animation="border" size="sm" className="me-2" />
                ) : (
                  "Review & Proceed to Payment"
                )}
              </Button>
            </div>
          </>
        )}
      </Card>
    </Container>
  );
}